import React, {forwardRef, useImperativeHandle, useState} from 'react';
import {Button, Modal} from "react-bootstrap";

function Commentaire(props, ref) {

    let commentaire;
    const [show, setShow] = useState(false);
    const [comment, setComment] = useState("");

    const updateShow = (show, save, value) => {
        setShow(show);

        if (show) {
            setComment(value);
        } else if (props.update && save) {
            props.update(value);
        }
    }

    useImperativeHandle(ref, () => {
        return {
            update: updateShow,
        }
    })

    return (
        <Modal show={show} onHide={() => updateShow(false, false, commentaire.value)} centered>
            <Modal.Header className={"bg-primary text-white"} closeButton>
                Commentaire
            </Modal.Header>
            <Modal.Body style={{padding: 0}}>
                <textarea defaultValue={comment} ref={r => commentaire = r} className={"form-control"} rows={6}
                          style={{resize: "vertical"}}/>
            </Modal.Body>
            <Modal.Footer>
                <Button size="lg" variant="primary" onClick={() => updateShow(false, true, commentaire.value)}>
                    Enregistrer
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default forwardRef(Commentaire);